import React from 'react';
import DialogBox from '../../../../../../constants/DialogBox';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../../../constants/InputTextBox';
import { useFormik } from 'formik';
import { EndBaseLine } from '../../../../../../constants/AppSpace';
import { Button } from '../../../../../../constants/Button';
import SelectInputBox from '../../../../../../constants/SelectInputBox';
import { LedgerTypeOptions, PaymentModeOptions, YesNoOptions } from '../../../../../../constants/Options';
import { handleNepaliInputChange, handleSelectBox } from '../../../../../../helpers/handleChange';
import { VoucherContextType } from '../../../../../../context/VoucherEntryContext';
import NepaliInputBox from '../../../../../../constants/NepaliInputBox';
import { postDataToTheServer } from '../../../../../../helpers/api';
import AppURL from '../../../../../../constants/AppURL';
import { ToastSuccess } from '../../../../../../constants/Toast';
interface SubLedgerCreateProps {
    openSub: boolean;
    data: any;
    context: VoucherContextType;
    account_id?: number;
    sub_account_sn?: number;
    setOnSub: React.Dispatch<React.SetStateAction<boolean>>;
    refetch?: () => void;
}
const SubLedgerCreateView: React.FC<SubLedgerCreateProps> = ({ openSub, data, setOnSub, account_id, refetch, sub_account_sn, context }) => {
    const subLedgerModeOptions =PaymentModeOptions(data?.mode_link);
    const { values: glid_value } = context;
    const initialValues = {
        sglsn: account_id?.toString() || "",
        sub_ledg_id: sub_account_sn?.toString() || "",
        sub_ledg_name: "",
        sub_ledg_name_nep: "",
        glid: glid_value.glid || "",
        diff_ac_on: "",
        status: "",
        mem_cate_id: "",
        show_det_mode: "",
        gl_type_cat: "",
        branch_id: "",
        dep_rate: "",
        link_mode: "",
    };
    const { values, errors, touched, resetForm, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: authorValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("sub_ledg_id", values.sub_ledg_id);
            formData.append("sub_ledg_name", values.sub_ledg_name);
            formData.append("sub_ledg_name_nep", values.sub_ledg_name_nep);
            formData.append("glid", values.glid);
            formData.append("diff_ac_on", values.diff_ac_on === "1" ? "1" : "0");
            formData.append("status", values.status === "1" ? "1" : "0");
            formData.append("mem_cate_id", values.mem_cate_id);
            formData.append("show_det_mode", values.show_det_mode === "1" ? "1" : "0");
            formData.append("gl_type_cat", values.gl_type_cat);
            formData.append("dep_rate", "0");

            try {
                await postDataToTheServer(AppURL.AccountURL + "account/sub/ledger/ledger/list/view/", formData).then((res) => {

                    if (res?.status === 201) {
                        ToastSuccess({ message: res?.message });
                        action.resetForm();
                        refetch?.();
                    }
                    action.resetForm();
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <DialogBox headerName='Sub Ledger Add' open={openSub} close={() => setOnSub(false)}>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <InputTextBox
                            type='number'
                            label='GLID'
                            name='glid'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            disabled={true}
                            value={values.glid}
                            placeholder='10'
                            required={false}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <InputTextBox
                            type='number'
                            label='Sub Account ID'
                            name='sub_ledg_id'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            disabled={true}
                            value={values.sub_ledg_id}
                            placeholder='10'
                            required={false}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <InputTextBox
                            type='number'
                            label='SGLSN'
                            name='sglsn'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            disabled={true}
                            value={values.sglsn}
                            placeholder='10'
                            required={false}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <InputTextBox
                            type='text'
                            label='Sub Ledger Name'
                            name='sub_ledg_name'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            disabled={false}
                            error={errors.sub_ledg_name}
                            touched={touched.sub_ledg_name}
                            value={values.sub_ledg_name}
                            placeholder='Enter Sub Ledger Name'
                            required={true}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
                        <NepaliInputBox
                            label="Sub Ledger Name(Nepali)"
                            name='sub_ledg_name_nep'
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'sub_ledg_name_nep' })}
                            value={values.sub_ledg_name_nep}
                            error={errors.sub_ledg_name_nep}
                            handleBlur={handleBlur}
                            touched={touched.sub_ledg_name_nep}
                            placeholder='Enter Sub Ledger Name(Nepali)'
                            required={true} />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label="Ledger Type"
                            options={LedgerTypeOptions}
                            name='gl_type_cat'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select ledger type'
                            value={values.gl_type_cat}
                            touched={touched.gl_type_cat}
                        />
                    </Grid>
                    
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label="Different A/C On"
                            options={YesNoOptions}
                            name='diff_ac_on'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select Different AC'
                            value={values.diff_ac_on}
                            touched={touched.diff_ac_on}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label="Show Rpt Details"
                            options={YesNoOptions}
                            name='show_det_mode'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select details mode'
                            value={values.show_det_mode}
                            touched={touched.show_det_mode}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label="Status"
                            options={YesNoOptions}
                            name='status'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select status'
                            value={values.status}
                            touched={touched.status}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={20}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>
        </DialogBox>
    )
}

export default SubLedgerCreateView